export default "__VITE_ASSET__mtSHu6hX__"